import { render, staticRenderFns } from "./_header.vue?vue&type=template&id=6308fcbd&scoped=true&"
import script from "./_header.vue?vue&type=script&lang=js&"
export * from "./_header.vue?vue&type=script&lang=js&"
import style0 from "./_header.vue?vue&type=style&index=0&id=6308fcbd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308fcbd",
  null
  
)

export default component.exports